export enum SortType {
  Alias = "alias",
  ChangedDate = "changedDate",
  CreatedDate = "createdDate",
  Owner = "owner",
  Permissions = "permissions",
  Type = "geometryType",
  Count = "objectCount",
  Description = "description",
}

export enum SortOrder {
  ASC = "asc",
  DES = "desc",
}
